// extracted by mini-css-extract-plugin
export default {"semCartas":"SemCartas_semCartas__B5e3G","semCartas__icon":"SemCartas_semCartas__icon__fDVQS"};